module.exports = __webpack_public_path__ + "static/mimosa-9ca6e29e47b1fa3a16fc4282ae3c2b2c.mp3";